module.exports = __webpack_public_path__ + "img/logo-locatelli-min.3a545cfc.png";